import React, { useState } from 'react';

import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import { Typography } from '@material-ui/core';

export default function SidePanelRow(props) {
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const { name, count } = props.data;
    const { onClick } = props;
    const buttons = new Array(count).fill(null);
    const imageLocation = 'http://localhost:8080/Web/images/';
    const selectedStyle={
        width:70,
        height:70,
        border:'5px solid wheat',
    }
    const deselectedStyle={
        width:80,
        height:80,
    }

    return (
        <div style={{marginLeft:'20px'}}>            
            <div style={{display:'flex'}}>   
                <div style={{marginRight:'30px'}}>
                    <IconButton onClick={_ => {onClick(-1); setSelectedIndex(-1);}}
                        disabled={selectedIndex === -1}
                        color={((selectedIndex === -1) && 'primary') || 'inherit'}
                    >
                        <ClearIcon style={{width:75, height:75}}/>
                    </IconButton>
                    <Typography align='center'>Clear</Typography>
                </div>         
                {buttons.map((_, index) => (
                    <div key={index} style={{marginRight:'30px'}}>
                        <IconButton onClick={_ => {onClick(index); setSelectedIndex(index);}}
                            disabled={index === selectedIndex}                            
                            style={{padding:'10px'}}
                        >
                            <Avatar alt="Hair Preview" 
                                src={imageLocation + name + (index + 1) + '.png'}
                                style={(index === selectedIndex && selectedStyle) ||
                                    deselectedStyle}
                            />                                                        
                        </IconButton>
                        <Typography align='center'>{name + ' ' + (index + 1)}</Typography>
                    </div>
                ))}
            </div>
        </div>
    )
}